import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
  disabled = false,
  isTypeDrop = false,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      isDisabled={disabled}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);

        if (isTypeDrop) {
          formik.setFieldValue("value", "");
        }
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          // cursor: "pointer",
          cursor: state.isDisabled ? "not-allowed" : "pointer",
          opacity: state.isDisabled ? 0.8 : 1, // subtle fade for disabled options
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const AddSystemSettings = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();
  const [allDisabled, setAllDisabled] = useState(false);

  useEffect(() => {
    console.log("EDIt", editData);
    if (editData?.default_config == "1") {
      setAllDisabled(true);
    }

    if (editData?.id) {
      formik.setFieldValue("module", editData?.module);
      formik.setFieldValue("setting", editData?.setting);
      formik.setFieldValue("context", editData?.context);
      formik.setFieldValue("value", editData?.value);
      formik.setFieldValue("type", editData?.type);
      formik.setFieldValue("description", editData?.description);
    }
  }, [editData]);

  const module = [
    {
      key: "Lead",
      value: "lead",
    },
    {
      key: "Deal",
      value: "deal",
    },
    {
      key: "System",
      value: "system",
    },
  ];

  const typeArray = [
    {
      key: "Text",
      value: "string",
    },
    {
      key: "Number",
      value: "integer",
    },
  ];

  const moduleOptions = module?.map((each) => ({
    value: each.value,
    label: each.key,
  }));
  const typeOptions = typeArray?.map((each) => ({
    value: each.value,
    label: each.key,
  }));

  const optionsObj = editData?.opt_values
    ? JSON.parse(editData?.opt_values)
    : {};

  const dropdownOptions = Object.entries(optionsObj)?.map(([key, value]) => ({
    value: key, // id / key
    label: value, // display text
  }));
  const validationSchema = yup.object({
    module: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    context: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    value: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    type: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    description: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      module: "",
      setting: "",
      context: "",
      value: "",
      type: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        module: values.module,
        setting: values.context,
        context: values.context,
        value: values.type == "integer" ? Number(values.value) : values.value,
        type: values.type,
        description: values.description,
      };

      console.log("DATa", data);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `system-settings/update-setting/${editData?.id}`
            : `system-settings/add-setting`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>
            {editData?.id ? "Edit System Settings" : "Add System Settings"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Module */}
                  <FeildWraper>
                    <FormLabel required>Module</FormLabel>
                    <CustomSelect
                      name="module"
                      options={moduleOptions}
                      formik={formik}
                      placeholder="Search or select Module..."
                      disabled={allDisabled}
                    />

                    {/* <SelectSearch
                      name="module"
                      placeholder="- Select Module -"
                      onChange={(val) => {
                        formik?.setFieldValue("module", val);
                      }}
                      value={formik?.values.module}
                      options={moduleOptions}
                      menuPosition="fixed"
                    /> */}
                    {formik.touched.module && formik.errors.module && (
                      <FeildError>{formik.errors.module}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Context */}

                  <FeildWraper>
                    <FormLabel required>Context</FormLabel>
                    <input
                      type="text"
                      name="context"
                      value={formik.values.context}
                      onChange={formik.handleChange}
                      placeholder="context"
                      disabled={allDisabled}
                    />
                    {formik.touched.context && formik.errors.context && (
                      <FeildError>{formik.errors.context}</FeildError>
                    )}
                  </FeildWraper>

                  {editData?.type == "dropdown" ? null : (
                    <FeildWraper>
                      <FormLabel required>Type</FormLabel>
                      <CustomSelect
                        name="type"
                        options={typeOptions}
                        formik={formik}
                        placeholder="Select Type..."
                        disabled={allDisabled}
                        isTypeDrop={true}
                      />
                      {formik.touched.type && formik.errors.type && (
                        <FeildError>{formik.errors.type}</FeildError>
                      )}
                    </FeildWraper>
                  )}

                  {/* Value */}
                  <FeildWraper
                    width={editData?.type == "dropdown" ? "100%" : "50%"}
                  >
                    <FormLabel required>Value</FormLabel>

                    {editData?.type == "dropdown" ? (
                      <CustomSelect
                        name="value"
                        options={dropdownOptions}
                        formik={formik}
                        placeholder="Search or Select value..."
                      />
                    ) : (
                      <>
                        {formik.values.type == "integer" ? (
                          <input
                            type="number"
                            name="value"
                            value={formik.values.value}
                            onChange={formik.handleChange}
                            placeholder="Enter number"
                          />
                        ) : (
                          <input
                            type="text"
                            name="value"
                            value={formik.values.value}
                            onChange={formik.handleChange}
                            placeholder="Enter text"
                          />
                        )}
                      </>
                    )}
                    {formik.touched.value && formik.errors.value && (
                      <FeildError>{formik.errors.value}</FeildError>
                    )}
                  </FeildWraper>

                  {/* description */}
                  <FeildWraper width="100%">
                    <FormLabel required>Description</FormLabel>

                    <textarea
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      rows={6}
                      placeholder="Write description here..."
                      disabled={allDisabled}
                    />
                    {formik.touched.description &&
                      formik.errors.description && (
                        <FeildError>{formik.errors.description}</FeildError>
                      )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddSystemSettings;
